import { chakra, Text } from '@chakra-ui/react';

export const NotificationText = chakra(Text, {
  baseStyle: {
    fontWeight: 'bold',
    fontFamily: 'var(heading)',
    textTransform: 'uppercase',
  },
});
